import CareersBlock from './blocks/careers';
import ContactForm from './components/contact-form';
import Faq from './components/faq';
import HeaderSlider from "./header-slider";
import Models from './models';
import ModelBlock from './blocks/models';
import ModelPageSlider from "./model-page-slider";
import ModelOptions from "./options";
import BlockSlider from './components/block-slider';
import NewsAndResourcesBlock from "./blocks/news-and-resources";
import PhotoGallery from "./components/photo-gallery";
import RangeSlider from './components/range-slider';
import StickyMenu from "./sticky-menu";
import TestimonialsBlock from "./blocks/testimonials";
import LocationsMap from "./blocks/locations-map";

jQuery(document).ready(() => {
    new StickyMenu();
    const careersBlock = document.querySelector('.careers-block');
    if (careersBlock) {
        new CareersBlock();
    }
    const faqSection = document.querySelector('.faq-section');
    if (faqSection) {
        new Faq();
    }
    const body = document.querySelector('body');
    if (body.classList.contains('home')) {
        new HeaderSlider();
    }
    const blockSlider = document.querySelector('.block-slider');
    if (blockSlider) {
        new BlockSlider();
    }
    const models = document.querySelector('#models');
    if (models) {
        new Models();
    }
    const modelsBlock = document.querySelector('.models__block');
    if (modelsBlock) {
        new ModelBlock();
    }
    const modelPageSlider = document.querySelector('.model-header-slider');
    if (modelPageSlider) {
        new ModelPageSlider();
    }
    const filterSliders = document.querySelector('#filter-sliders');
    if (filterSliders) {
        new RangeSlider();
    }
    const contactFormContainer = document.querySelector('.contact-form__container');
    if (contactFormContainer) {
        new ContactForm();
    }
    const optionsModal = document.querySelector('#options-modal');
    if (optionsModal) {
        new ModelOptions();
    }
    const newsBlock = document.querySelector('#news__resources__block');
    if (newsBlock) {
        new NewsAndResourcesBlock();
    }
    const testimonialsBlock = document.querySelector('#testimonials__block');
    if (testimonialsBlock) {
        new TestimonialsBlock();
    }
    const photoGallery = document.querySelector('.category__gallery');
    if (photoGallery) {
        new PhotoGallery();
    }
    const map = document.querySelector('.locations-map');
    if (map) {
        new LocationsMap();
    }
});